import { useRef } from "react";
import { useField } from "../useField/index";
var nameCounter = 0;
function getCount() {
    if (nameCounter < Number.MAX_SAFE_INTEGER) {
        return nameCounter++;
    }
    nameCounter = Number.MIN_SAFE_INTEGER;
    return nameCounter;
}
export function useWatchField(dependencies) {
    var ref = useRef("_watcher_".concat(getCount())), name = ref.current;
    var dependencyValues = useField({
        dependencies: dependencies,
        name: name
    }).dependencyValues;
    return dependencyValues;
}
